<script lang="ts">
  import { BurgerButton } from '@shared/ui/buttons/burger';
  import { Button } from '@shared/ui/buttons/button';
  import { Portal } from '@shared/ui/portal';
  import { Sidebar } from '@shared/ui/sidebar';
  import { theme, ThemeModes } from '@shared/ui/theme';
  import { cn } from '@shared/utils';

  import { History, mapHistoryData, type TokenHistory } from '@entities/history';

  import { CursorPagination } from '@features/pagination';

  import { tokensHistorySidebarActivity } from '../models/tokens-history-sidebar-activity-model';

  export let latestTokenHistoryData: TokenHistory['data'] = [];
  export let preservedTokenHistoryData: TokenHistory['data'] = [];

  export let loadMoreFunction: () => Promise<void>;
  export let refreshFunction: () => Promise<void>;

  let loading = false;

  async function refreshHistoryData() {
    loading = true;
    await refreshFunction();
    loading = false;
  }

  function handleSidebarClose() {
    tokensHistorySidebarActivity.close();
  }

  $: hasNewItems =
    !latestTokenHistoryData?.[0]?.id && latestTokenHistoryData?.[0]?.id !== preservedTokenHistoryData?.[0]?.id;
</script>

<Portal>
  <Sidebar sidebarActivity="{$tokensHistorySidebarActivity}" handleClose="{handleSidebarClose}">
    <div class="{cn('filter-sidebar flex h-full flex-col', { dark: $theme === ThemeModes.Dark })}">
      <div class="flex items-center justify-between px-6 py-[22px]">
        <span class="text-default-900 dark:text-dark-900 font-inter text-xl font-semibold">History</span>
        <span class="flex gap-4">
          {#if hasNewItems}
            <Button
              size="sm"
              variant="secondary"
              iconName="retry"
              iconPosition="left"
              hugged
              on:click="{refreshHistoryData}">Refresh</Button
            >
          {/if}
          <span class="flex items-center md:hidden">
            <BurgerButton isActive on:click="{handleSidebarClose}" />
          </span>
        </span>
      </div>
      <div class="no-scrollbar flex-grow space-y-4 overflow-auto px-5 py-6">
        <div class="text-dark-50 space-y-3 dark:text-white">
          <CursorPagination {loading} {loadMoreFunction} isLoadMoreEnabled="{$tokensHistorySidebarActivity}">
            <History history="{mapHistoryData(preservedTokenHistoryData)}" />
          </CursorPagination>
        </div>
      </div>
    </div>
  </Sidebar>
</Portal>
